import { useRef } from "react";
import { Container, Form } from "react-bootstrap";
import { debounce } from "../helper/helper";

const Search = ({ setSearchTerm }) => {
  const inputRef = useRef(null);
  
  const handleSearch = debounce(
    evt => {
      evt.preventDefault();
      // const value = evt.target.value || tag;
      const value = inputRef.current.value;
      setSearchTerm(value);
    })

  return (
    <section className="search">
      <Container className="mini-container">
        <Form onSubmit={handleSearch} onReset={handleSearch}>
          <Form.Group controlId="search">
            <Form.Label className="visually-hidden">Search</Form.Label>
            <Form.Control ref={inputRef} type="search" placeholder="Search for images" onChange={handleSearch} />
          </Form.Group>
        </Form>
      </Container>
    </section>
  );
};

export default Search;
